import { openApi } from '@/api/request'

export default {
  getUserInfo (userName) {
    const url = `/Rccl.OpenApi/User/GetUserPointApi`
    return openApi.post(url, {userName})
  },
  getUserDetail (userName) {
    const url = `/Rccl.OpenApi/User/GetUserEditInfoApi`
    return openApi.get(url, {
      params: {
        userName,
        v: (new Date()).getTime()
      }
    })
  },
  checkSignIn (userName) {
    return openApi.post('/Rccl.OpenApi/User/MemberSignInPointApi', { userName })
  },
  getLoginQrCode () {
    return openApi.get('/Rccl.OpenApi/User/GetQrCode', {
      params: {
        v: (new Date()).getTime()
      }
    })
  },
  isQrCodeLogin (token) {
    return openApi.get('/Rccl.OpenApi/User/CheckIsLogin', {
      params: {
        token,
        v: (new Date()).getTime()
      }
    })
  },
  signIn ( userName ) {
    return openApi.post('/Rccl.OpenApi/User/MemberSignInPointApi', {
        userName,
        source: 'online'
    })
  },
  getUserAllInfo (userName) {
    return openApi.post('/Rccl.OpenApi/UserCenter/Info', { userName })
  },
  userEditInfo (userName) {
    return openApi.post('/Rccl.OpenApi/User/GetUserEditInfoInPersonalCenter', { userName })
  },
  subEditInfo (data) {
    return openApi.post('/Rccl.OpenApi/User/SetUserEditInfoApi', data)
  },
  pyName ({lastName, firstName}) {
    return openApi.get('/Rccl.Core/Pinyin/GetPinyinName', {
      params: {
        lastName,
        firstName
      }
    })
  },
  getCountryList () {
    return openApi.get('/Rccl.OpenApi/Country/CountryList')
  },
  submitSuggestion (suggestion) {
    return openApi.post('/Rccl.OpenApi/UserCenter/SubmitSuggestionApi', suggestion)
  },
  getSuggestionCategory (userName) {
    return openApi.post('/Rccl.OpenApi/UserCenter/Suggestion', { userName })
  },
  userRelevanceInfoHP (userName) {
    return openApi.post('/Rccl.OpenApi/User/GetUserRelevanceInfoHPApi', { userName })
  },
  GetUserRelevanceInfoHP (userName) {
    return openApi.post('/Rccl.OpenApi/User/GetUserRelevanceInfoHPApi', {
      userName,
      source: 'online'
    })
  },
  getAllCoupons (userName) {
    return openApi.get('/Rccl.OpenApi/User/UserCenterCouponApi', {
        params: {
            userName,
            v: (new Date()).getTime()
        }
    })
  },
  picCode (sessionKey) {
    return openApi.get('/Rccl.OpenApi/User/PictureVerificationCode', {
      params:{
        sessionKey,
        v: (new Date()).getTime()
      }
    })
  },
  smsCode (requestData) {
    return openApi.post('/Rccl.OpenApi/User/SendSmsCode', requestData)
  },
  SendSmsCodeWithPicCodeV3 (requestData) {
    return openApi.post('/Rccl.OpenApi/User/SendSmsCodeWithPicCodeV3', requestData)
  },
  // smsCodeLogin (requestData) {
  //   return openApi.post('/Rccl.OpenApi/User/SendSmsCodeV2', requestData)
  // },
  smsCodeLogin (requestData) {
    return openApi.post('/Rccl.OpenApi/User/SendSmsCodeV3', requestData)
  },
  login (requestData) {
    return openApi.post('/Rccl.OpenApi/User/LoginHp', requestData)
  },
  registeredMember (requestData) {
    return openApi.post('/Rccl.OpenApi/User/RegisterMemberHP', requestData)
  },
  isRegistered (mobile) {
    return openApi.get('/Rccl.OpenApi/User/isRegister', {
      params: {
        mobile,
        v: (new Date()).getTime()
      }
    })
  },
  isRegisteredMember (mobile) {
    return openApi.get('/Rccl.OpenApi/User/isRegisteredMember', {
      params: {
        phone: mobile,
        v: (new Date()).getTime()
      }
    })
  },
  checkHasRegister (telephone, callingCode) {
    return openApi.post('/Rccl.OpenApi/User/checkHasRegister', {
      telephone,
      callingCode
    })
  },
  getContact(userName) {
    return openApi.get('/Rccl.OpenApi/User/GetUserContactsByUserName', {
      params: {
        userName: userName,
        v: (new Date()).getTime()
      }
    })
  },
  getContactInPersonalCenter(userName) {
    return openApi.get('/Rccl.OpenApi/User/GetUserContactsByUserNameInPersonalCenter', {
      params: {
        userName: userName,
        v: (new Date()).getTime()
      }
    })
  },
  setDefaultContact (requestData) {
    return openApi.post('/Rccl.OpenApi/User/RcclSetDefaultContactHP', requestData)
  },
  updateContact(contact) {
    return openApi.post('/Rccl.OpenApi/User/UpdateUserContact', contact)
  },
  createContact(contact) {
    return openApi.post('/Rccl.OpenApi/User/CreateUserContact', contact)
  },
  deleteContact (contact) {
    return openApi.post('/Rccl.OpenApi/User/DeleteUserContact', contact)
  },
  getCoupons (userName) {
    return openApi.get('/Rccl.OpenApi/User/UserCouponApi', {
      params: {
        userName,
        source: 'online',
        v: (new Date()).getTime()
      }
    })
  },
  getAvailableCoupons (userName) {
    return openApi.get('/Rccl.OpenApi/User/GetUserAvailableCoupons', {
      params: {
        userName,
        source: 'online',
        v: (new Date()).getTime()
      }
    })
  },
  GetGuestPolicyByCruise (requestData) {
    return openApi.get('/Rccl.OpenApi/PageContent/GetGuestPolicyByCruise', {
      params: requestData
    })
  },
  bindLoyalty (requestData) {
    return openApi.post('/Rccl.OpenApi/User/bindLoyalty', requestData)
  },
  createCas (requestData) {
    return openApi.post('/Rccl.OpenApi/User/CreateCasMember', requestData)
  },
  getPcpToken () {
    return openApi.post('/Rccl.OpenApi/User/GetPcpToken', {})
  },
  unBindWechat (userName) {
    return openApi.post('/Rccl.OpenApi/UserCenter/UnBindWechat', {
      userName
    })
  },
  signInReward () {
    return openApi.post('/Rccl.OpenApi/User/RegisterMemberHP', {
      source: 'pc'
    })
  },
  getWechatEWM () {
    return openApi.post('/Rccl.OpenApi/UserCenter/GetQrCode', {
      source: 'online'
    })
  },
  checkIsLogin (token) {
    return openApi.post('/Rccl.OpenApi/UserCenter/CheckIsLogin', {
      token
    })
  },
  checkBind (openId) {
    return openApi.post('/Rccl.OpenApi/UserCenter/WechatBindSuccess', {
      openId
    })
  },
  // 获得是否同意过最终的隐私政策-202508
  getUserAgreeVersionIsEffective(userName) {
    return openApi.post("/Rccl.OpenApi/User/GetUserAgreeVersionIsEffective", { userName })
  },
  // 确认同意最终的隐私政策-202508
  agreeToTheLastAgreement(requestData) {
    return openApi.post("/Rccl.OpenApi/User/AgreeToTheLastAgreement", requestData)
  },
  /**
   * 根据类型获取最新协议
   * @param requestData
   * userAgreementType: 1用户协议 2隐私政策 3皇家游享荟项目细则
   * @returns {*}
   */
  getAgreementByType(requestData) {
    return openApi.post("/Rccl.OpenApi/User/GetAgreementByType", requestData)
  },
  /**
   * 获取协议版本号列表
   * @param requestData
   * userAgreementType: 1用户协议 2隐私政策 3皇家游享荟项目细则
   * showMaxVersion: true:最新版本 false:历史版本 默认false，是否显示最大版本号
   * @returns {*}
   */
  getAgreeVersionNumberListByType(requestData) {
    return openApi.post("/Rccl.OpenApi/User/GetAgreeVersionNumberListByType", requestData)
  },
  /**
   * 根据参数获取协议
   * @param requestData
   * userAgreementType: 1用户协议 2隐私政策 3皇家游享荟项目细则
   * ver: 版本号
   * effectiveDateStr: 生效时间
   * id: 协议id
   * @returns {*}
   */
  getAgreementByParams(requestData) {
    return openApi.post("/Rccl.OpenApi/User/GetAgreementByParams", requestData)
  },
  // 获得是否同意过最终的隐私政策
  getUserVersionIsEffective (userName) {
    return openApi.post("/Rccl.OpenApi/User/GetUserVersionIsEffective", { userName })
  },
  // 确认同意隐私条款接口
  agreePrivacyPolicy (userName) {
    return openApi.post("/Rccl.OpenApi/User/AgreePrivacyPolicy", { userName })
  },
  // 获取用户是否开启隐私保护
  changePrivacyProtectionIsOpen (userName) {
    return openApi.post("/Rccl.OpenApi/UserCenter/ChangePrivacyProtectionIsOpen", { userName })
  },
  // 更新用户是否开启隐私保护
  // updateUserPrivacyProtection (requestData) {
  //   return openApi.post("/Rccl.OpenApi/UserCenter/UpdateUserPrivacyProtection", requestData)
  // }

  // 更新用户是否开启隐私保护
  updateUserPrivacyProtection (requestData) {
    return openApi.post("/Rccl.OpenApi/UserCenter/UpdateUserPrivacyProtectionV1", requestData)
  },
  // 退会&注销验证
  memberCancellationCheck (data) {
    return openApi.post('/Rccl.OpenApi/MemberCancellation/Check', data)
  },
  // 退会&注销提交
  memberCancellationSubmit (data) {
    return openApi.post('/Rccl.OpenApi/MemberCancellation/Submit', data)
  },
  // 是否会员token
  checkIsMemberByToken(userName) {
    return openApi.get(`/Rccl.OpenApi/User/IsRegisteredMemberApi?userName=${userName}`)
  }
}
